import { useMemo } from "react";
import classnames from "classnames";

import { Row, Column } from "common/core/responsive";

import { Header } from "./components/header";
import { EmptyState } from "./components/empty_state";
import { EmailRiskSignals, PhoneRiskSignals } from "./components/risk_signals";
import { PersonalInformation } from "./components/personal_information";
import { Sidebar } from "./components/sidebar";
import { IpAddress } from "./components/ip_address";
import { DocumentViewer } from "./components/document_viewer";
import type { CustomerSigner } from "./index.fragment.graphql";
import Styles from "./index.module.scss";

type Props = {
  customerSigner: CustomerSigner;
  documentBundle: {
    organizationTransaction: {
      id: string;
    };
  };
  proofDefend: boolean;
};

export function Customer({ customerSigner, documentBundle, proofDefend }: Props) {
  const customerSignerAttemptCount = useMemo(
    () => customerSigner.signerIdentities?.length ?? 0,
    [customerSigner],
  );
  return (
    <>
      <Row>
        <Column>
          <Header
            customerSigner={customerSigner}
            documentBundle={documentBundle}
            proofDefend={proofDefend}
          />
        </Column>
      </Row>
      {customerSignerAttemptCount ? (
        <Row className={Styles.contentContainer}>
          <Column xs={12} lg={7} xl={8} className={Styles.contentColumn}>
            {proofDefend && (
              <Row className={Styles.contentContainer}>
                <Column xs={12} lg={6}>
                  <EmailRiskSignals customerSigner={customerSigner} />
                </Column>
                <Column xs={12} lg={6}>
                  <PhoneRiskSignals customerSigner={customerSigner} />
                </Column>
              </Row>
            )}
            <DocumentViewer customerSigner={customerSigner} />
            {proofDefend && <IpAddress customerSigner={customerSigner} />}
            <Row>
              <Column>
                <PersonalInformation customerSigner={customerSigner} />
              </Column>
            </Row>
          </Column>
          <Column
            xs={12}
            lg={5}
            xl={4}
            className={classnames(Styles.contentColumn, Styles.sidebar)}
          >
            <Row>
              <Column>
                <Sidebar customerSigner={customerSigner} showSignals={proofDefend} />
              </Column>
            </Row>
          </Column>
        </Row>
      ) : (
        <Row>
          <Column>
            <EmptyState />
          </Column>
        </Row>
      )}
    </>
  );
}
